import { render, staticRenderFns } from "./UsersUpdate.vue?vue&type=template&id=367db589"
import script from "./UsersUpdate.vue?vue&type=script&lang=js"
export * from "./UsersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports